export default __webpack_public_path__ + "static/media/Pressure.3aef646b.svg";